import { SUITS, SUIT_SYMBOL, rankOf, suitOf, rankChar } from "@/poker/cards";

const SIZES = {
  xs: "w-7 h-10 text-[11px]",
  sm: "w-9 h-[52px] text-xs sm:w-11 sm:h-16 sm:text-sm",
  md: "w-11 h-16 text-sm sm:w-14 sm:h-20 sm:text-lg",
  lg: "w-12 h-[68px] text-base sm:w-16 sm:h-[88px] sm:text-xl",
};

export const PlayingCard = ({ card, faceDown = false, size = "md", dim = false, delay = 0, testId }) => {
  const base = `${SIZES[size]} rounded-md sm:rounded-lg select-none shrink-0 card-deal`;
  const style = { animationDelay: `${delay}ms` };
  if (faceDown || card === undefined || card === null) {
    return <div data-testid={testId} style={style} className={`${base} card-back ${dim ? "opacity-40" : ""}`} />;
  }
  const suit = SUITS[suitOf(card)];
  const red = suit === "h" || suit === "d";
  const r = rankChar(rankOf(card));
  return (
    <div
      data-testid={testId}
      style={style}
      className={`${base} card-face relative flex flex-col justify-between p-1 sm:p-1.5 font-mono font-bold leading-none ${red ? "text-red-600" : "text-slate-900"} ${dim ? "opacity-40 grayscale" : ""}`}
    >
      <span>{r === "T" ? "10" : r}</span>
      <span className="self-center text-[1.6em] leading-none">{SUIT_SYMBOL[suit]}</span>
      <span className="self-end rotate-180">{r === "T" ? "10" : r}</span>
    </div>
  );
};

export const CardSlot = ({ size = "md", testId }) => (
  <div data-testid={testId} className={`${SIZES[size]} rounded-md sm:rounded-lg border border-dashed border-white/15 bg-black/10`} />
);
